export default __webpack_public_path__ + "static/media/Furniture 800 x 300 Mobile.dcc1c022.jpg";